import { useState } from "react";
import { Col, Row } from "react-bootstrap";

export const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [buttonText, setButtonText] = useState('Submit');



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || email.indexOf("@") === -1) return;

    setButtonText("Sending...");

    const encode = (data) => {
      return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
    };

    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "newsletter", email: email })
      });
      setButtonText("Subscribed!");
      setEmail('');
      setTimeout(() => {
        setButtonText("Submit");
      }, 3000);
    } catch (error) {
      setButtonText("Failed");
      setTimeout(() => {
        setButtonText("Submit");
      }, 3000);
    }
  };

  return (
    <Col lg={12}>
      <div className="newsletter-bx wow slideInUp">
        <Row>
          <Col lg={12} md={6} xl={5} className="d-flex align-items-center">
            <h3>Subscribe to my mailing list</h3>
          </Col>
          <Col md={6} xl={7}>
            <form name="newsletter" method="POST" data-netlify="true" onSubmit={handleSubmit}>
              <input type="hidden" name="form-name" value="newsletter" />
              <div className="new-email-bx">
                <input value={email} type="email" name="email" onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" />
                <button type="submit" className={buttonText === "Subscribed!" ? "success-btn" : ""}>{buttonText}</button>
              </div>
            </form>
          </Col>
        </Row>
      </div>
    </Col>
  )
}
